<template>
  <AppModal  :id="id" :isLoading="isLoading">
    <template v-slot:title>
      <h3 class="text-center mb-4">{{title}} ?</h3>
      <p class="mb-4" v-if="message">{{message}}</p>
    </template>
    <template v-slot:button>
      <AppConfirmButtons
        :submit-text="$getConst.pages.button.yes"
        :cancel-text="$getConst.pages.button.cancel"
        :is-loading="isLoading"
        variant="danger"
        @onSubmit="submit"
        @onCancel="close"
        />
    </template>
  </AppModal>
</template>

<script>
  import AppModal from "./AppModal";
  import AppConfirmButtons from "../utils/AppConfirmButtons";
  export default {
    name: "AppConfirmationModal",
    components: {AppConfirmButtons, AppModal},
    props:{
      id: String,
      title: String,
      message: String
    },
    data() {
      return {
        isLoading: false
      }
    },
    methods: {
      close() {
        this.$bvModal.hide(this.id);
        this.isLoading = false;
        this.$emit('onCancel');
      },
      submit() {
        this.isLoading = true;
        this.$emit('onConfirm');
      },
    }
  }
</script>

<style scoped>

</style>
